module.exports = __webpack_public_path__ + "img/15_14.cee156e6.png";